<template>
  <div class="user-routing-page">
    <div class="page-header">
      <div>
        <h1>Пользователи</h1>
        <!-- <p>Описание</p> -->
      </div>
    </div>
    <nav class="tabs">
      <button v-for="tab in tabs" :key="tab.key" type="button" class="tab" :class="{ active: activeTab === tab.key }"
        @click="activeTab = tab.key">
        {{ tab.label }}
        <span v-if="tab.badge" class="tab-badge">{{ tab.badge }}</span>
      </button>
    </nav>

    <section class="tab-panel">
      <user-list-section v-show="activeTab === 'userlist'" />
      <role-list-section v-show="activeTab === 'rolelist'" />
    </section>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import UserListSection from './user-routing/UsersListSection.vue'
import RoleListSection from './user-routing/RoleListSection.vue'

export default {
  name: 'UserRoutuinPage',
  components: { UserListSection, RoleListSection },
  setup() {
    const activeTab = ref('userlist')
    const tabs = computed(() => [
      { key: 'userlist', label: 'Пользователи' },
      { key: 'rolelist', label: 'Роли' },
    ]);
    return { activeTab, tabs }
  }
}
</script>

<style scoped>
.user-routing-page {
  background: #f5f7fb;
  min-height: 100vh;
  padding: 24px;
  color: #1f2937;
}

.page-header {
  margin-bottom: 18px;
}

.page-header h1 {
  color: #1f2937;
  font-size: 26px;
  font-weight: 700;
  margin: 0 0 4px;
}

.page-header p {
  color: #6b7280;
  font-size: 13px;
  margin: 0;
}

.tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 16px;
}

.tab {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  color: #6b7280;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 16px;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.tab:hover {
  background: #eff6ff;
  color: #2563eb;
}

.tab.active {
  border-bottom-color: #2563eb;
  color: #2563eb;
}

.tab-badge {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 7px;
  border-radius: 10px;
  background: #fee2e2;
  color: #991b1b;
  font-size: 11px;
  font-weight: 700;
}

.tab-panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
  padding: 18px;
}

:deep(.section button) {
  transition: filter 0.15s ease;
}

:deep(.section button:not(:disabled):hover) {
  filter: brightness(0.96);
}

:deep(.section button:not(:disabled):active) {
  filter: brightness(0.92);
}
</style>